// Bottom Navigation Component - Responsive Multi-Platform
import { useApp } from '../hooks/useApp';
import { SCREENS } from '../config/constants';
import Icons from './Icons';
import { Text } from './ui';

function BottomNav() {
    const { currentScreen, setCurrentScreen } = useApp();

    const navItems = [
        { screen: SCREENS.HOME, icon: Icons.Home, label: 'Trang chủ' },
        { screen: SCREENS.HISTORY, icon: Icons.History, label: 'Lịch sử' },
        { screen: SCREENS.SETTINGS, icon: Icons.Settings, label: 'Cài đặt' },
    ];

    return (
        <div className="bottom-nav-wrapper">
            <div className="bottom-nav-inner">
                <div className="flex justify-around py-2 safe-bottom">
                    {navItems.map(({ screen, icon: Icon, label }) => (
                        <button
                            key={screen}
                            onClick={() => setCurrentScreen(screen)}
                            className={`flex flex-col items-center gap-1 px-4 sm:px-6 py-2 transition-all touch-target ${currentScreen === screen ? 'opacity-100' : 'opacity-50'
                                }`}
                        >
                            <div className={currentScreen === screen ? 'text-primary' : 'text-theme-primary'}>
                                <Icon />
                            </div>
                            <Text
                                variant="small"
                                className={currentScreen === screen ? '!text-primary' : ''}
                            >
                                {label}
                            </Text>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default BottomNav;

